export const FETCH_SALES_ORDERS_SUCCESS = 'fetch_sales_orders_success'
export const ADD_SALES_ORDERS_SUCCESS = 'add_sales_orders_success'
export const FETCH_SALES_ORDER_DETAILS_SUCCESS = 'fetch_sales_order_details_success'
export const UPDATE_SALES_ORDER_SUCCESS = 'update_sales_order_success'
export const ADD_TRANSACTION_SUCCESS = 'add_transaction_success'
